// Pages made of several views. Each view has its own address
// (base/slug) and shows as a sub-item under its page in the sidebar.
// Kept apart from the pages so the sidebar can list them without loading
// the pages themselves. adminOnly items show only to Assets Register
// administrators.
export const SECTIONS = {
  assets: {
    base: "/assets-register/all-assets",
    items: [
      { slug: "add-asset", label: "Add Asset" },
      { slug: "asset-pool", label: "Asset Pool" },
      { slug: "locations", label: "Asset Locations" },
      { slug: "asset-list", label: "Asset List" },
      { slug: "revaluation", label: "Asset Revaluation" },
      { slug: "disposal", label: "Asset Disposal" },
      { slug: "transfer", label: "Asset Transfer" },
      { slug: "code-settings", label: "Asset Code Settings" },
      { slug: "delete", label: "Delete Asset", adminOnly: true },
    ],
  },
  tangible: {
    base: "/assets-register/tangible-report",
    items: [
      { slug: "asset-report", label: "Asset Report" },
      { slug: "summary", label: "Summary Report" },
      { slug: "locations", label: "Locations Report" },
      { slug: "ppe", label: "PPE Report" },
      { slug: "disposal", label: "Disposal Report" },
      { slug: "revaluation", label: "Revaluation Report" },
      { slug: "exhausted", label: "Exhausted Report" },
      { slug: "auditors", label: "Report For Auditors" },
    ],
  },
  intangible: {
    base: "/assets-register/intangible-report",
    items: [
      { slug: "asset-report", label: "Asset Report" },
      { slug: "summary", label: "Summary Report" },
      { slug: "locations", label: "Locations Report" },
      { slug: "schedule", label: "Schedule Report" },
      { slug: "disposal", label: "Disposal Report" },
      { slug: "revaluation", label: "Revaluation Report" },
      { slug: "exhausted", label: "Exhausted Report" },
      { slug: "auditors", label: "Report For Auditors" },
    ],
  },
  rightOfUse: {
    base: "/assets-register/right-of-use-report",
    items: [
      { slug: "asset-report", label: "Asset Report" },
      { slug: "summary", label: "Summary Report" },
      { slug: "locations", label: "Location Report" },
      { slug: "exhausted", label: "Exhausted Report" },
      { slug: "auditors", label: "Report For Auditors" },
    ],
  },
  summary: {
    base: "/assets-register/summary-report",
    items: [
      { slug: "classification", label: "Asset Classification Report" },
      { slug: "categories", label: "Categories Summary Report" },
      { slug: "locations", label: "Locations Summary Report" },
      { slug: "auditors", label: "Auditors Summary Report" },
    ],
  },
  settings: {
    base: "/assets-register/user-page",
    items: [
      { slug: "personal", label: "Personal Info" },
      { slug: "security", label: "Security" },
    ],
  },
};
